export default "__VITE_ASSET__B569tn51__"